import moment from 'moment';

export const formatDateStringToDate = (date: Date | string): Date =>
  (moment(date).format('YYYY-MM-DD') as unknown) as Date;
